import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';
import Statement from '../components/Statement';
import Disciplines from '../components/Disciplines';

const Landing = () => {
  return (
    <>
      <Helmet>
        <title>Interior Design Studio Sofia | Element by Elena Mustakova</title>
        <meta name="description" content="Boutique interior design studio for spaces with character. Residential, hospitality, visual identity. Sofia · Milano · across Europe." />
        <link rel="canonical" href="https://mustakova.com/" />
      </Helmet>
      
      <div>
        <Hero />
        <Statement />
        <Disciplines />
      </div>
    </>
  );
};

export default Landing;
